import "./styles/base.css";
import "./styles/sections.css";

import Nav from "./components/Nav";
import Hero from "./components/Hero";
import Statement from "./components/Statement";
import Work from "./components/Work";
import Approach from "./components/Approach";
import Credentials from "./components/Credentials";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

export default function App() {
  return (
    <>
      <a className="skip-link" href="#work">
        Skip to the work
      </a>
      <Nav />
      <main id="main">
        <Hero />
        <Statement />
        <Work />
        <Approach />
        <Credentials />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
